import { ecsClient } from './index';

interface SubmitFeedbackParams {
  rating: number;
  message?: string;
}

interface SubmitFeedbackResponse {
  success: boolean;
}

const FeedbackServices = {
  submitFeedback: async (
    params: SubmitFeedbackParams,
  ): Promise<SubmitFeedbackResponse> => {
    try {
      const response = await ecsClient.post<SubmitFeedbackResponse>(
        '/feedback',
        {
          rating: params.rating,
          message: params.message,
        },
      );

      return response.data;
    } catch (error: any) {
      console.error('[FeedbackServices] Submit feedback error:', error);
      return { success: false };
    }
  },
};

export default FeedbackServices;
